import { Fragment } from "react";
import clsx from "clsx";
import { Listbox, Transition } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faChevronDown, faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import Icon3D from "../ui/icon-3d";
import { usePlatform } from "../../store/use-platform";
import { PLATFORM_IDS, PLATFORM_LOOK } from "../../utils/status";

export default function PlatformSwitcher() {
  const { platform, setPlatform } = usePlatform();
  const look = platform === "all" ? { label: "All platforms", icon: faLayerGroup, tone: "indigo" as const } : PLATFORM_LOOK[platform];
  const options = [{ id: "all", label: "All platforms", icon: faLayerGroup, tone: "indigo" as const }, ...PLATFORM_IDS.map((id) => ({ id, ...PLATFORM_LOOK[id] }))];

  return (
    <Listbox value={platform} onChange={setPlatform}>
      {({ open }) => (
        <div className="relative">
          <Listbox.Button
            aria-label="Platform"
            className={clsx("flex h-10 items-center gap-2.5 rounded-xl border bg-surface pl-1.5 pr-3 transition-all", open ? "border-accent ring-4 ring-accent/10" : "border-edge hover:border-edge-strong")}
          >
            <Icon3D icon={look.icon} tone={look.tone} size="sm" flat className="!h-7 !w-7 !rounded-lg !text-[12px]" />
            <span className="hidden font-[Gilroy-Medium] text-[13px] text-heading-color sm:inline">{look.label}</span>
            <FontAwesomeIcon icon={faChevronDown} className={clsx("text-[10px] text-label-muted transition-transform duration-300", open && "rotate-180")} />
          </Listbox.Button>
          <Transition as={Fragment} enter="transition ease-out duration-200" enterFrom="opacity-0 scale-95 -translate-y-1" enterTo="opacity-100 scale-100 translate-y-0" leave="transition ease-in duration-150" leaveFrom="opacity-100" leaveTo="opacity-0 scale-95">
            <Listbox.Options className="absolute right-0 z-40 mt-2 w-60 origin-top-right rounded-2xl border border-edge bg-surface-elevated p-1.5 shadow-overlay focus:outline-none">
              {options.map((option) => (
                <Listbox.Option
                  key={option.id}
                  value={option.id}
                  className={({ active }) => clsx("flex cursor-pointer items-center gap-3 rounded-xl px-2.5 py-2 font-[Gilroy-Medium] text-[13px] transition-colors", active ? "bg-overlay-mid text-heading-color" : "text-light-gray")}
                >
                  {({ selected }) => (
                    <>
                      <Icon3D icon={option.icon} tone={option.tone} size="sm" flat />
                      <span className="flex-1">{option.label}</span>
                      {selected ? <FontAwesomeIcon icon={faCheck} className="text-[11px] text-accent" /> : null}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      )}
    </Listbox>
  );
}
